import { getCityPending, getCitySuccess, getCityFail, 
    deleteCityPending, deleteCitySuccess, deleteCityFail,
    getSCityPending, getSCitySuccess, getSCityFail, 
    createCityPending, createCitySuccess, createCityFail, 
    modifyCityPending, modifyCitySuccess, modifyCityFail } from "./citySlice";
import { fetchAllCity, cityDelete, cityCreation, cityModify, fetchSingleCity } from "../../../api/userApi";
import Swal from "sweetalert2";

export const getAllCity = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getCityPending());
        const result = await fetchAllCity();
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

        //console.log('allCityData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const citydetails = JSON.parse(JSON.stringify(myObj.cities));
        const citydetails1 = JSON.parse(JSON.stringify(citydetails));
        
        if (citydetails) {
        
            return dispatch(getCitySuccess(citydetails));
        }
        dispatch(getCityFail("City is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getCityFail(err.msg));

    }
}

export const cityDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteCityPending());
        const result = await cityDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteCitySuccess("City deleted"))
        : dispatch(deleteCityFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteCityFail(err.msg));
    }
    
}

export const newCityCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createCityPending());
        const result = await cityCreation(frmDt);
        //console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createCitySuccess("city created"))
            : dispatch(createCityFail(result.message));

           // console.log("CountryCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
         console.log(error);
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error')
         console.log(err.msg);
       
    //    const row = err.map((er, i) => {
    //     console.log('loop');
    //     console.log(er.msg);
    //     console.log('loop param');

    //     console.log(er.param);
    //         if (i === er.length - 1) {
    //           return er.param+' '+er.msg+'. ';
    //         }
    //         return er.param+' '+er.msg+' ';
    //       });
    //       console.log('row');
    //       console.log(row);
          dispatch(createCityFail());
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
       
       
       
    }

}

export const getSingleCity = (id) => async (dispatch) => {
    
 
    try {
     //call the api
    dispatch(getSCityPending());
    const result = await fetchSingleCity(id);
   // const userData=JSON.parse(result.user);
 console.log('CityData ');
 //console.log(result);
 console.log(result.countries);
 
 //console.log('check user profile out if');
    if(result.cities[0] && result.cities[0].id){
    //console.log('check user profile');
        return dispatch(getSCitySuccess(result.cities[0]));
    }
    dispatch(getSCityFail("City is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
   // console.log(err.msg);
  
    dispatch(getSCityFail(err.msg));
 
 }
    
 
 }


export const cityModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyCityPending());
        const result = await cityModify(frmDt);
        result.status === "success"
            ? dispatch(modifyCitySuccess(result))
            : dispatch(modifyCityFail(result));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        console.log(err);
        Swal.fire(err.msg, '', 'error')
        dispatch(modifyCityFail(err.msg));
    }

}
